import { SuccessPlaceholder, WizardFooter, WizardTitle } from "@components"
import  PresendSummary from "./PresendSummary"
import { PaperAirplaneIcon } from "@heroicons/react/24/outline"
import { PropTypes } from "prop-types"

const Step3 = ({ 
  counts,
  filter, 
  handlePrevious, 
  handleFinish, 
  isComplete,
  isSubmitting,
}) => {
  const successMessage = counts.selected === 1 
    ? `${counts.selected} email has been queued for sending. This will be sent out shortly. For updates view Manage Emails & Notifications.`
    : `${counts.selected} emails have been queued for sending. These will be sent out shortly. For updates view Manage Emails & Notifications.`

  return (
    <div>
      {!isComplete && (
        <WizardTitle
          title="Step 3 of 3 - Confirm & Send"
          description="Review the summary and click 'Send Invitations' to send the emails."
          icon={<PaperAirplaneIcon />}
        />
      )}

      {!isComplete && <PresendSummary counts={counts} filter={filter} />}

      {isComplete && (
        <SuccessPlaceholder 
          title="Invitation Emails Queued" 
          message={successMessage}
        />
      )}

      <WizardFooter 
        currentStep={3} 
        totalSteps={3} 
        isPreviousButtonDisabled={isSubmitting || isComplete}
        previousCaption="Filter Guardians" 
        nextCaption={isComplete ? 'Close' : 'Send Invitations'}
        handlePrevious={() => handlePrevious()} 
        handleNext={() => handleFinish()} 
        isSubmitting={isSubmitting}
      />
    </div>
  )
}

Step3.propTypes = {
  counts: PropTypes.shape({
    deselected: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  
  filter: PropTypes.object.isRequired,
  handlePrevious: PropTypes.func.isRequired,
  handleFinish: PropTypes.func.isRequired,
  isComplete: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default Step3